// extracted by mini-css-extract-plugin
export default {"video":"VZGkDGuz9M","videoContent":"TRqz5iGXZ0","iframe":"d6roy8QqQW"};